import type { Timestamp } from 'firebase/firestore';

export type TUnixDate = { nanoseconds: number; seconds: number };

export const getKeyFromEnum = <T extends object>(
  enumObj: T,
  value: T[keyof T],
): keyof T | undefined =>
  (Object.keys(enumObj) as Array<keyof T>).find(
    (key) => enumObj[key] === value,
  );

export interface ITimestamp {
  lastUsed?: Timestamp | null;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface IObjectId {
  id?: string;
  uid?: string;
}

export interface ICommonDataType extends IObjectId {
  key: string;

  [key: string]: unknown;
}

export interface IMetadata extends ITimestamp {
  createdBy?: { uid: string; name: string };
  updatedBy?: { uid: string; name: string };
}

export enum EStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  DELETED = 'DELETED',
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  PUBLISHED = 'PUBLISHED',
}

export enum EPrivacyStatus {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  UNLISTED = 'UNLISTED',
}

export enum EDurationTypes {
  HOUR = 'Hour',
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
  YEAR = 'Year',
  FOREVER = 'Forever',
}

type TDurationPeriod = number;
export type TDuration = {
  type: keyof typeof EDurationTypes;
  period: TDurationPeriod;
};
